/* eslint-disable */
import { useState } from 'react'
import '../globalStyle.scss'
import { Button, Paper, Box, Alert } from '@mui/material'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useApiPost } from '../apiCalls/useApi'
import { updatePassword } from '../apiCalls/authApi'
import { useNavigate } from 'react-router-dom'
import { updatePasswordSchema } from '../components/PasswordField/validation'
import PasswordWithConfirmation from '../components/PasswordField/PasswordWithConfirmation'

const schema = updatePasswordSchema()

export default function UpdatePassword() {
  const [isLoading, setIsLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const updatePasswordMutation = useApiPost(updatePassword)
  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      newPassword: '',
      confirmPassword: '',
    },
    resolver: yupResolver(schema),
  })

  const onSubmit = handleSubmit(async (data) => {
    setIsLoading(true)
    setErrorMessage('')

    try {
      await updatePasswordMutation({
        password: data.newPassword,
      })
      alert('Password updated successfully! Please Login with new password.')
      reset()
      navigate('/logout')
    } finally {
      setIsLoading(false)
    }
  })

  return (
    <Paper square elevation={0} className='paperStyle'>
      <div style={{ height: 'calc(100% - 40px)' }}>
        <div
          className='organizationInfoSettingTitle'
          style={{
            marginLeft: '16px',
            marginTop: '16px',
            marginBottom: '24px',
          }}
        >
          Update Password
        </div>
        {errorMessage && (
          <Alert severity='error' sx={{ mb: 3 }}>
            {errorMessage}
          </Alert>
        )}

        <Box
          component='form'
          onSubmit={onSubmit}
          sx={{
            maxWidth: 400,
            mt: 3,
            ml: 2,
          }}
        >
          <PasswordWithConfirmation
            control={control}
            errors={errors}
            disabled={isLoading}
          />

          <Button
            type='submit'
            variant='contained'
            disabled={isLoading}
            sx={{
              mt: 2,
              mr: 2,
            }}
          >
            {isLoading ? 'Updating...' : 'Update Password'}
          </Button>
        </Box>
      </div>
    </Paper>
  )
}
